module.exports = __webpack_public_path__ + "static/why-money.c4a62a59.jpg";